// global.$ = global.jQuery = require('jquery');
require('jquery')

//Höhenanpassungsscript

if(parent.frames.length > 0) {
	var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
	var eventer = window[eventMethod];
	var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
	var thisSiteHeight = $('body').height() + 0;
	var id, eventSource, eventOrigin;
	var faqClick = false;

	eventer(messageEvent, function(event) {
		eventSource = event.source;
		eventOrigin = event.origin;

		var data = event.data;
		if(!data || data.length === 0) {
			return;
		}

		data = data.split('-');
		if(data.length !== 2) {
			return;
		}

		if(data[0] !== 'height') {
			return;
		}

		id = parseInt(data[1], 10);
		if(isNaN(id)) {
			return;
		}

		eventSource.postMessage(id + '-' + thisSiteHeight + '-' + 0, eventOrigin);

		function resize(offsetPosition) {
			if(window.self != window.top) {
				var thisSiteHeight = $('body').height() + 60;

				if(offsetPosition !== undefined) {
					eventSource.postMessage(id + '-' + thisSiteHeight + '-' + offsetPosition, eventOrigin);
				}
				else {
					eventSource.postMessage(id + '-' + thisSiteHeight, eventOrigin);
				}
			}

			if(!faqClick && window.location.search.match(/\?token=\w+/i) !== null) {
				document.getElementById('formSection').scrollIntoView();
			}
		}

		if(typeof $.incognito !== 'object') $.incognito = {};
		if(typeof $.incognito.hoehenanpassung !== 'object') $.incognito.hoehenanpassung = {};
		$.incognito.hoehenanpassung.resize = resize;

		$(document).on('groesseGeaendert', function(event, offsetPosition) {
			setTimeout(function(){ resize(offsetPosition); }, 100);
		});

		$(window).resize(function() {
			setTimeout(function(){ resize(); }, 200);
		});

		$(document).ready(function() {
			setTimeout(function(){ resize(); }, 200);
		});

        $(".btn-more").click(function() {
			setTimeout(function(){ resize(); }, 200);
        });
	}, false);
}

window.addEventListener("load", function () {

	// Init
	var domElements = {
        cards: document.querySelectorAll(".teaser"),
        showMoreBtn: document.getElementById('show-more'),
		videos: document.querySelectorAll('[data-threeq]'),
    }
	var active = {
		limit: 4
	}

	// Init 3Q videos
	if(domElements.videos.length) {
		domElements.videos.forEach(newVideo => {
			init3QVideo(newVideo)
		})
	}

	// Execute filter with default values and watch show more button
    if (domElements.showMoreBtn) {
		applyFilter();
        domElements.showMoreBtn.addEventListener('click', function(event) {
            active.limit += 4;
            applyFilter(); 
        });
    }

    function applyFilter() {
        // Hide all cards
        [].forEach.call(domElements.cards, function(el) {
            el.classList.add("teaser--hide");
        });

        // Show only cards inside of limit
        var filteredArray = [...domElements.cards];
        var showElements = filteredArray.slice(0, active.limit);

        [].forEach.call(showElements, function(el) {
            el.classList.remove("teaser--hide");
        });

        // Toggle show more button
        if(filteredArray.length <= active.limit) {
            domElements.showMoreBtn.style.visibility = 'hidden';
        } else {
            domElements.showMoreBtn.style.visibility = 'visible';
        }
    }

	function init3QVideo(video) {
		const config = JSON.parse(decodeURI(video.dataset.threeq))
		const playerId = 'video-3q-' + config.playoutId

		video.setAttribute('id', playerId)
		new js3q({
			dataid: config.playoutId,
			container: playerId,
			cast: false,
			key: config.playoutKey,
			timestamp: Date.now()
		})
	}
}, false);